<!-- <h4 class="title">Follow up Save</h4> -->
<mat-icon style="text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">close</mat-icon>

<div class="row">
    <div class="col-md-12">
        <h4 class="title-f">Account List</h4>
        <!-- <div class="card-box">
            <div class="row" style="padding: 0px 0px 23px 10px;">
                <div class="col-md-3">
                  <h5 class="form-lable">Loan No./Account No.:</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Settlement:</h5>
                    <input type="text" pInputText placeholder="" value="">
                  </div>
                  <div class="col-md-3">
                    <h5 class="form-lable">Financier:</h5>
                    <input type="text" pInputText placeholder="" value="">
                  </div>
                <div class="col-md-3">
                  <h5 class="form-lable">Customer Name:</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                <div class="col-md-3">
                  <h5 class="form-lable">DPD>=:</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                <div class="col-md-3">
                  <h5 class="form-lable">Amount Overdue>=:</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                <div class="col-md-3">
                  <h5 class="form-lable">Product:</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                <div class="col-md-3">
                  <h5 class="form-lable">Queue:</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                <div class="col-md-3">
                  <h5 class="form-lable">POS>=</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                <div class="col-md-3">
                    <h5 class="form-lable">Unit Level:</h5>
                    <input type="text" pInputText placeholder="" value="">
                  </div>
                <div class="col-md-3">
                  <h5 class="form-lable">Unid Code:</h5>
                  <input type="text" pInputText placeholder="" value="">
                </div>
                
                <div class="col-md-3 mt-20">
                        <button type="button" class="btn btn-primary">Search</button>
                   </div>
            
              </div>

        </div> -->
    </div>
</div>



<ng-container>

    <!-- <h4 class="title">Collection Recording</h4> -->
  
    <div class="doc-table">
        <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
            [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['type']">
            <ng-template pTemplate="header">
                <tr style="text-align: center;">
                    <th>Account Number</th>
                    <th>Name</th>
                    <th>Portfolio</th>
                    <th>Product</th>
                    <th>OD Amount</th>
                    <th>OS Amount</th>
                    <th>Bucket</th>
                    <th>Last Action Code</th>
                    <th>Last Result Code</th>
                    <th>Last followup taken by</th>
                    <th>Last followup taken on</th>
                </tr>
                <tr style="text-align: center;">
                    <td>1</td>
                    <td (click)="show()"><a class="link-a">01234567899</a></td>
                    <td>Vignesh</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                    <td>NA</td>
                </tr>
            </ng-template>
         </p-table>  </div>
    </div>
    <br>

</ng-container>
